export const APITAGS = Object.freeze({
    PUBLIC: "public",
    INTERNAL: "internal",
  });